import { Placeholder } from '@sitecore-jss/sitecore-jss-nextjs';
import { C08LinkListProps } from './C08LinkList.types';
import { LINK_LIST_ITEM_CONTAINER } from '@/shared/static';
import { LinkListProps } from '@ahc-digital/component-library';
import { useConditionalRendering } from '@/shared/useConditionalRendering';
import { getDroplink } from '@/shared/param-utils';

export function GetLinkListModel(props?: C08LinkListProps): LinkListProps {
  type t = LinkListProps;

  const { rendering, params, fields } = props || {};

  const { renderText, renderRichText, renderLink } = useConditionalRendering();

  return {
    headline: renderText(fields?.Headline),
    supportCopy: renderRichText(fields?.SupportCopy),
    cta: renderLink(fields?.CTA),
    links: rendering && <Placeholder name={LINK_LIST_ITEM_CONTAINER} rendering={rendering} />,
    headlineAlignment: getDroplink<t['headlineAlignment']>(params?.HeadlineAlignment, 'left'),
    supportCopyAlignment: getDroplink<t['supportCopyAlignment']>(
      params?.SupportCopyAlignment,
      'left'
    ),
    ctaAlignment: getDroplink<t['ctaAlignment']>(params?.CTAAlignment, 'left'),
    headlineTag: getDroplink<t['headlineTag']>(params?.HeadlineTag, 'p'),
    columnAlignment: getDroplink<t['columnAlignment']>(params?.ColumnAlignment, 'left'),
    backgroundColor: getDroplink<t['backgroundColor']>(params?.BackgroundColor, 'white'),
    numColumns: getDroplink<t['numColumns']>(params?.NumberOfColumns, '2'),
    ctaStyle: getDroplink<t['ctaStyle']>(params?.CTAStyle, 'button'),
  };
}
